module.exports = __webpack_public_path__ + "static/media/NeptunePreSale.60d7d174.svg";